export const SET_DEFAULT_SIDE_FILTERS = 'SET_DEFAULT_SIDE_FILTERS'
export const LOADING_DEFAULT_SIDE_FILTERS = 'LOADING_DEFAULT_SIDE_FILTERS'
export const UPDATE_SIDE_FILTER = 'UPDATE_SIDE_FILTER'
export const UPDATE_SEARCH_FILTER = 'UPDATE_SEARCH_FILTER'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
export const CLEAR_SINGLE_FILTER = 'CLEAR_SINGLE_FILTER'
export const UPDATE_FILTER = 'UPDATE_FILTER'
